import React from "react";
import PropTypes from "prop-types";
import StackTrace from "stacktrace-js";
import Angie from "~/utils/angie";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
    this.setState({
      hasError: true,
    });
    StackTrace.fromError(error).then((result) => {
      Angie.logger.error(error, {
        stackTrace: result,
        componentStack: errorInfo.componentStack,
        errorLocation: this.props.errorLocation,
      });
    });
  }

  render() {
    if (this.state.hasError && !Angie.page_reload_needed) {
      // You can render any custom fallback UI
      return <p className="tw-text-xl tw-text-red-alert">⚠ Something went wrong...</p>;
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  errorLocation: PropTypes.string,
};

ErrorBoundary.defaultProps = {
  errorLocation: "",
};

export default ErrorBoundary;
